import { z } from 'zod';

const baseUrl = window.location.origin;
const apiBaseUrl = baseUrl.replace('insights', 'api');
const authBaseUrl = baseUrl.replace('insights', 'auth');
const portalBaseUrl = baseUrl.replace('insights', 'portal');
const miaApiBaseUrl = baseUrl.replace('insights', 'miaapi');
const miaWebBaseUrl = baseUrl.replace('insights', 'mia');

const envSchema = z
  .object({
    VITE_API_BASE_URL: z.string().url().catch(apiBaseUrl),
    VITE_AUTH_BASE_URL: z.string().url().catch(authBaseUrl),
    VITE_PORTAL_BASE_URL: z.string().url().catch(portalBaseUrl),
    VITE_MIA_API_BASE_URL: z.string().url().catch(miaApiBaseUrl),
    VITE_MIA_WEB_BASE_URL: z.string().url().catch(miaWebBaseUrl),
  })
  .transform((data) => ({
    API_BASE_URL: data.VITE_API_BASE_URL,
    AUTH_BASE_URL: data.VITE_AUTH_BASE_URL,
    PORTAL_BASE_URL: data.VITE_PORTAL_BASE_URL,
    MIA_API_BASE_URL: data.VITE_MIA_API_BASE_URL,
    MIA_WEB_BASE_URL: data.VITE_MIA_WEB_BASE_URL,
    /**
     * New relic configuration required for BAD-450.
     *
     * As of this card, there are two "global" env variables present in CI/CD for new relic:
     * `VITE_NEW_RELIC_AGENT_CONFIG` and `VITE_NEW_RELIC_ENABLED`, which are used only in MBC.
     *
     * Given that we have no need to dynamically enable new relic in this project and the same
     * configuration is used regardless of the environment, we're adding a fixed configuration to
     * avoid introducing new variables.
     */
    NEW_RELIC_AGENT_CONFIG: {
      info: {
        applicationID: '1120535975',
        beacon: 'bam.nr-data.net',
        errorBeacon: 'bam.nr-data.net',
        licenseKey: '2529b23ae2',
        sa: 1,
      },
      init: {
        ajax: {
          deny_list: ['bam.nr-data.net'],
        },
        browser_consent_mode: {
          enabled: false,
        },
        distributed_tracing: {
          enabled: true,
        },
        performance: {
          capture_detail: false,
          capture_marks: false,
          capture_measures: true,
        },
        privacy: {
          cookies_enabled: true,
        },
      },
      loader_config: {
        accountID: 2005250,
        agentID: 1120535975,
        applicationID: '1120535975',
        licenseKey: '2529b23ae2',
        trustKey: 2005250,
      },
    },
    /**
     * PostHog project token is a public, client-side key that is safe to ship in the bundle, and
     * the same project is used across every environment. Following the New Relic precedent above,
     * we hard-code it here rather than wiring up per-environment build variables (the deploy
     * pipeline only injects VITE_APP_VERSION).
     */
    POSTHOG_TOKEN: 'phc_vXXj5vbuHHK3WGFtwWwnDMwXW38cDXH6bFVhPDVpHfkk',
    POSTHOG_HOST: 'https://us.i.posthog.com',
    SUPPORT_EMAIL: 'bestservice@mend.com',
    MUI_LICENSE_KEY:
      '18f3f5977834f0e333dc9355f6da5d1fTz0xMTMzNTUsRT0xNzc5NDk0Mzk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMy0yMDI0LEtWPTI=',
  }));

export const config = envSchema.parse(import.meta.env);
